module.exports = __webpack_public_path__ + "static/img/hs_banner_bg_1.8f883e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/hs_banner_bg_1.png
// module id = iFer
// module chunks = 1